module.exports = __webpack_public_path__ + "static/media/train-card20.fe79fb6b.jpg";